import { createSlice } from "@reduxjs/toolkit";

import {
  fetchRoles,
  fetchUserById,
  fetchUsers,
} from "./thunk";
import { IUserSlice } from "./type";

export const userSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    roles:[],
    userDetail: null
  } as IUserSlice,
  reducers: {
  },
  extraReducers: (builder) => {
    // fetchCustomers
    builder.addCase(fetchUsers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchUsers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.users = action.payload;
    });
    builder.addCase(fetchUsers.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
    
    // fetchRoles
    builder.addCase(fetchRoles.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchRoles.fulfilled, (state, action) => {
      state.isLoading = false;
      state.roles = action.payload;
    });
    builder.addCase(fetchRoles.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
    
    // fetchUserById
    builder.addCase(fetchUserById.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchUserById.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userDetail = action.payload;
    });
    builder.addCase(fetchUserById.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // createUpdateCustomer
    // builder.addCase(createUpdateCustomer.pending, (state) => {
    //   state.isLoading = true;
    // });
    // builder.addCase(createUpdateCustomer.fulfilled, (state, action) => {
    //   state.isLoading = false;
    // });
    // builder.addCase(createUpdateCustomer.rejected, (state) => {
    //   state.isLoading = false;
    //   state.isError = true;
    // });
  },
});

export const { reducer } = userSlice;